// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__1MfoW","active":"Navigation_active__hKnsz Navigation_link__1MfoW"};